import React, { useState } from "react";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { Grid, Typography, InputAdornment } from "@material-ui/core";
import Snackbar from "../CommonComponent/Snackbar/Snackbar";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import {
  StyledPaper,
  StyledMainDiv,
  StyledTextField,
  StyledButtonSignIn,
  StyledTipTextDiv,
} from "./forgetPassword.css";

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const history = useHistory();

  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    snackbarMsg: "",
    type: "",
  });

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setMessage("");
      setError("");
      setLoading(true);
      await resetPassword(email);
      setMessage("Check your inbox for further instructions");
      setSnackbarProps({
        open: true,
        snackbarMsg: "Check your inbox for further instructions!",
        type: "success",
      });
    } catch {
      setError("Failed to reset password");
      setSnackbarProps({
        open: true,
        snackbarMsg: "Failed to reset password",
        type: "error",
      });
    }

    setLoading(false);
  }

  return (
    <div style={{paddingTop: '10%'}}>
      <StyledPaper style={{backgroundColor: 'white'}}>
        <form onSubmit={handleSubmit}>
          <StyledMainDiv>
            <Typography variant="h5">Forget Password</Typography>

            <p>Enter your Email to reset your password</p>
            <Grid container>
              <Grid item xs={12}>
                <StyledTextField
                  variant="outlined"
                  size="small"
                  type="email"
                  placeholder="Email"
                  onChange={(e) => setEmail(e.target.value.trim())}
                  value={email}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MailOutlineIcon />
                      </InputAdornment>
                    ),
                  }}
                  required
                />
              </Grid>
              <StyledTipTextDiv>
                <Grid item xs={12}>
                  <Link
                    underline="hover"
                    sx={{
                      cursor: "pointer",
                      fontFamily: "var(--font-family-Raleway)",
                    }}
                    onClick={() => {
                      history.push("/");
                    }}
                  >
                    Sign In?
                  </Link>
                </Grid>
              </StyledTipTextDiv>
            </Grid>
            <div>
              <StyledButtonSignIn type="submit">Send password reset link</StyledButtonSignIn>
            </div>
          </StyledMainDiv>
        </form>
      </StyledPaper>
      <Snackbar
        open={snackbarProps.open}
        message={snackbarProps.snackbarMsg}
        type={snackbarProps.type}
      ></Snackbar>
    </div>
  );
}
